import { render } from "./KioskItemModifierNew.vue?vue&type=template&id=8f63fe32&scoped=true"
import script from "./KioskItemModifierNew.vue?vue&type=script&lang=js"
export * from "./KioskItemModifierNew.vue?vue&type=script&lang=js"

import "./KioskItemModifierNew.vue?vue&type=style&index=0&id=8f63fe32&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f63fe32"]])

export default __exports__